/* ============================================================================
   TPS PRICE BOARD v2: the board's behaviour, lifted VERBATIM out of
   sections/tps-flavour-board-v2.liquid (Orion, 2026-10-05, Flash R7 kill-list #7).
   Every line between "BODY START" and "BODY END" is the former inline script,
   unchanged, except the two values Liquid used to print into it:
     - the section root     -> passed in (was getElementById('fbv2-<section.id>'))
     - routes.cart_url      -> the section's data-cart-url (was printed into openThemeCart)
   Read the section file's header before changing anything here: the compliance
   controls (no counts, one price, silent filtering, the queueing add path, the
   drawer handshake, D-6 committed-choice navigation) live in this code.
   Loaded with defer: it runs once the document is parsed, before DOMContentLoaded.
   ============================================================================ */
(function(){
  function fbv2Boot(root){
  if (!root || root.__fbv2Boot) return;
  root.__fbv2Boot = true;
  var CART_URL = root.getAttribute('data-cart-url') || '/cart';
  /* ---- BODY START ---- */

  var srch    = root.querySelector('[data-srch]'),
      qclr    = root.querySelector('[data-qclr]'),
      fbtn    = root.querySelector('[data-fbtn]'),
      pageEl  = root.querySelector('[data-page]'),
      boardEl = root.querySelector('[data-board]'),
      fbrand  = root.querySelector('[data-fbrand]'),
      fsize   = root.querySelector('[data-fsize]'),
      pread   = root.querySelector('[data-pread]'),
      plab    = root.querySelector('[data-plab]'),
      pto     = root.querySelector('[data-pto]'),
      phlab   = root.querySelector('[data-phlab]'),
      psel    = root.querySelector('[data-psel]'),
      PLO     = root.querySelector('[data-plo]'),
      PHI     = root.querySelector('[data-phi]'),
      clearBtn= root.querySelector('[data-clear]'),
      eolRoute= root.querySelector('[data-eol-route]'),
      eolClear= root.querySelector('[data-eol-clear]'),
      barEl   = root.querySelector('[data-bar]'),
      cartt   = root.querySelector('[data-cartt]'),
      viewBtn = root.querySelector('[data-viewcart]'),
      receiptEl = root.querySelector('[data-receipt]'),
      receiptList = root.querySelector('[data-receipt-list]'),
      receiptTot = root.querySelector('[data-receipt-tot]'),
      sheetShow = root.querySelector('[data-sheetshow]'),
      sheetClear = root.querySelector('[data-sheetclear]');
  /* ══ COPY — every customer-visible word the filter controls print, in ONE place. T7 (2026-10-04) strings are
     NEEDS THEMIS: change a word here and nowhere else. {n} is filled by the script.
       filterOn : the Filter button while filters are on; {n} = how many filters are on (brands + sizes + a moved
                  price window). It counts the customer's own choices, never products, never stock.
       show     : the button that closes the sheet onto the board.
       A post-filter result count ("Show {n}") is BLOCKED: reg 20(1)(a), Themis 2026-10-04 (GATE-themis-board-batch).
       Do not add it back without a solicitor's sign-off (SOLICITOR-BRIEF Q-COUNT). ══ */
  var COPY = { filter: 'Filter', filterOn: 'Filter \u00b7 {n}', close: 'Close', show: 'Show results' };
  function copy(k, n){ return String(COPY[k]).replace('{n}', String(n)); }
  /* Last known board/page intersection — Form view and the filter sheet keep the
     sticky bar up while the cart has items even if intersection would hide it. */
  var PAGE_IN_VIEW = true;

  /* ---------- index the server-rendered cards; no second data payload ----------
     THE SCRIPT READS THE DOM THE SERVER PRODUCED. There is no rows.json fetch, no
     client hydration and no template literal building a card. Every card, every
     price, every size chip and every variant id is in the delivered HTML before
     this file runs. The rails derive at runtime from rendered cards only. */
  var IDX = [].slice.call(root.querySelectorAll('[data-row]')).map(function(el){
    var chips = [].slice.call(el.querySelectorAll('[data-chip]'));
    return {
      el:  el,
      b:   el.getAttribute('data-b') || '',
      n:   el.getAttribute('data-n') || '',
      r:   el.getAttribute('data-r') || '~',
      hay: el.getAttribute('data-hay') || '',
      sz:  (el.getAttribute('data-sz') || '').split(',').filter(Boolean),
      chips: chips,
      cents: chips.map(function(c){ return parseInt(c.getAttribute('data-c') || '0', 10) || 0; })
    };
  });

  var CART_Q = {}, CART_K = {}, SESSION_VIDS = {};

  /* grams() is the guard of the size axis at the client build: null = not a size */
  function grams(label){
    var m = /^\s*([\d.]+)\s*(kg|gms|gm|g)?\s*$/i.exec(label || '');
    if (!m) return null;
    var n = parseFloat(m[1]);
    if (!isFinite(n) || n <= 0) return null;
    if (m[2]) return /^kg$/i.test(m[2]) ? n * 1000 : n;
    return (n >= 20 && n <= 2000) ? n : null;
  }
  var SIZES = (function(){
    var seen = {}, out = [];
    IDX.forEach(function(r){ r.sz.forEach(function(s){ if(!seen[s] && grams(s) !== null){ seen[s]=1; out.push(s); } }); });
    return out.sort(function(a,b){ return grams(a) - grams(b); });
  })();
  var BRANDS = (function(){
    var seen = {}, out = [];
    IDX.forEach(function(r){ if (r.b && !seen[r.b]){ seen[r.b] = 1; out.push(r.b); } });
    return out.sort(function(a,b){ return a.toLowerCase().localeCompare(b.toLowerCase()); });
  })();

  /* brand-page mode: the page's single vendor is the board; the roster of every master-board
     vendor (with each one's own collection URL) drives the rail as LINKS. */
  var BRAND_PAGE = root.getAttribute('data-brand-page') || '';
  var MASTER_URL = root.getAttribute('data-master-url') || '/collections/all-shisha-flavours';
  var ROSTER = [];
  try { var rosterEl = root.querySelector('[data-roster]'); if (rosterEl) ROSTER = JSON.parse(rosterEl.textContent || '[]') || []; } catch(e){ ROSTER = []; }
  /* R7H01-C2 (Themis 2026-10-05): the roster is explicitly A to Z, case-insensitive, in JS (never all_vendors order,
     never popularity/stock). Sorted once here so the rail and the Dropdown Brand select can never disagree. */
  ROSTER = ROSTER.filter(function(v){ return v && v.n && v.h; });
  ROSTER.sort(function(a,b){ return a.n.toLowerCase().localeCompare(b.n.toLowerCase()); });

  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function money(cents){
    var v = cents/100;
    return '$' + (v % 1 ? v.toFixed(2) : v.toFixed(0));
  }
  function slug(s){ return String(s).toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,''); }
  function rowName(row){ var el = row.querySelector('[data-name]'); return el ? el.textContent : ''; }
  function keys(o){ var k = []; for (var x in o) if (o.hasOwnProperty(x)) k.push(x); return k; }

  /* ══ THE DISPLAYED ORDER is the order the SERVER delivered, which is the
     collection's own Shopify sort. There is deliberately NO client-side re-sort
     here. A previous `orderPlate()` re-appended every card alphabetically at
     init and silently beat both the admin setting and the Liquid sort — that is
     the bug that made the Sort dropdown look broken. Do not re-add one. If the
     board order is ever wrong, fix the COLLECTION's sort in Shopify admin.
     Cards still carry `data-r` (the static tps.board_rank metafield) as an inert
     hook if a merchant-set order is ever wanted again; nothing reads it today. ══ */

  /* ---------- committing a size on a card ---------- */
  function commit(row, chip){
    if (!chip) return;
    /* Solo chips are not a size switch — still refresh the row's qty chrome for Form view. */
    if (chip.hasAttribute('data-solo')){ syncRow(row); return; }
    var chips = row.querySelectorAll('[data-chip]');
    [].forEach.call(chips, function(c){ c.setAttribute('aria-pressed', String(c === chip)); });
    var m   = chip.getAttribute('data-m') || '';
    var vid = chip.getAttribute('data-vid') || '';
    var sz  = chip.getAttribute('data-s') || '';
    var priceEls = row.querySelectorAll('[data-price]');
    [].forEach.call(priceEls, function (el) { el.textContent = m; });
    var idEl = row.querySelector('[data-tpsb-id]');
    if (idEl) idEl.value = vid;
    var sr = row.querySelector('[data-addsr]');
    if (sr) sr.textContent = 'Add ' + (row.getAttribute('data-b') || '') + ' ' + rowName(row) +
      ', ' + sz + ' to cart';
    syncRow(row);
  }

  /* ---------- the action box: [ Add ] at rest, [ − | N | + ] once the line exists ----------
     N is ALWAYS the cart's own line quantity for the selected variant (CART_Q), never a local
     tally. Every tap is accepted and queued per variant; the cell shows the optimistic figure
     unconfirmed while a request for that variant is in flight and turns solid when the last queued
     response confirms it; a refusal reverts to the last confirmed figure. Session memory only:
     SESSION_VIDS gates the in-cart view and is never stored, so a reload rests every card at Add.
     Minus steps down; at 0 the line is removed via /cart/change.js and the control returns to Add. */
  var ROWQ = {};
  var liveEl = document.querySelector('[data-tps-atc-live]');
  function say(m){ if (liveEl) liveEl.textContent = m; }
  /* batch F T-07 (Tiresias): the control that was focused is hidden by the swap (display:none via data-qty), so
     activeElement fell to BODY and the next Tab restarted at the top of the page. Hand focus to the control that
     took its place. preventScroll: nothing moved on the page. */
  function fbv2Focus(el){ if (!el) return; try { el.focus({ preventScroll: true }); } catch(e){ el.focus(); } }
  function rowSt(vid){ return ROWQ[vid] || (ROWQ[vid] = { opt: null, busy: false, capAt: null }); }
  function rowChip(row){ return row.querySelector('[data-chip][aria-pressed="true"], [data-chip][data-solo="1"]'); }
  function rowIdent(row){
    var chip = rowChip(row);
    return (row.getAttribute('data-b') || '') + ' ' + rowName(row) +
      (chip ? ', ' + (chip.getAttribute('data-s') || '') : '');
  }
  function rowMax(row){
    var chip = rowChip(row), m = chip ? parseInt(chip.getAttribute('data-max') || '', 10) : NaN;
    return isFinite(m) ? m : null;
  }
  function syncRow(row){
    var idEl = row.querySelector('[data-tpsb-id]'), ctl = row.querySelector('[data-add]');
    if (!idEl || !ctl) return;
    var vid = String(idEl.value || ''), st = ROWQ[vid], conf = CART_Q[vid] || 0;
    var pending = !!(st && st.opt !== null && (st.busy || st.opt !== conf));
    /* read BEFORE any mutation below: `up.disabled = true` under a focused + drops focus to BODY first */
    var ae = document.activeElement;
    /* Show optimistic qty including 0 so minus-to-remove flips back to Add immediately. */
    var n = pending ? (st.opt !== null ? st.opt : conf) : (SESSION_VIDS[vid] ? conf : 0);
    if (!n && SESSION_VIDS[vid] && !pending) delete SESSION_VIDS[vid];
    var max = rowMax(row);
    var capped = (max !== null && n >= max) || !!(st && st.capAt !== null && n >= st.capAt);
    ctl.setAttribute('data-qty', String(n));
    ctl.setAttribute('aria-busy', pending ? 'true' : 'false');
    var qn = ctl.querySelector('[data-qn]'), qsr = ctl.querySelector('[data-qsr]'),
        up = ctl.querySelector('[data-qup]'), dn = ctl.querySelector('[data-qdn]');
    var ident = rowIdent(row);
    if (qn) qn.textContent = n > 0 ? String(n) : '';
    if (qsr) qsr.textContent = n > 0 ? ('In cart, ' + n) : ' ';
    if (up){ up.setAttribute('aria-label', 'Add one more ' + ident); up.disabled = capped; }
    if (dn){
      dn.setAttribute('aria-label', n <= 1 ? ('Remove ' + ident + ' from cart') : ('Remove one ' + ident));
      dn.disabled = n <= 0;
    }
    /* Orion 2026-10-04 (d' report, finding 2): a REFUSED grid add swapped the stepper back to Add while focus
       was on +, and nobody took it: activeElement fell to BODY. The same swap in the other direction (Add ->
       stepper) was already handed over at the tap. Whichever control the swap hides, the one that took its
       place gets focus here, so every path through this function leaves focus on the row's live control. */
    if (ae && ctl.contains(ae)){
      if (!n && (ae === up || ae === dn)) fbv2Focus(row.querySelector('[data-addbtn]'));
      else if (n > 0 && ae.getAttribute('data-addbtn') !== null) fbv2Focus(up && !up.disabled ? up : dn);
    }
  }
  function syncRows(){
    IDX.forEach(function(r){ syncRow(r.el); });
    syncQuick();
  }

  /* ---------- Board / Form view switch (remembered) ----------
     FORM is one Brand → Flavour → Size cascade plate. Same fields as a card.
     Preference lives in localStorage; last Brand/Flavour/Size ride with it. */
  var VIEW_KEY = 'tps_fbv2_view';
  var FORM_KEY = 'tps_fbv2_form';
  var quickEl = root.querySelector('[data-quick]');
  var qForm = root.querySelector('[data-qform]');
  var qBrand = root.querySelector('[data-qbrand]');
  var qFlavour = root.querySelector('[data-qflavour]');
  var qSize = root.querySelector('[data-qsize]');
  var qPrice = root.querySelector('[data-qprice]');
  var qAddBtn = root.querySelector('[data-qaddbtn]');
  var qAddSr = root.querySelector('[data-qaddsr]');
  var qStep = root.querySelector('[data-qstep]');
  var qQn = root.querySelector('[data-qqn]');
  var qQsr = root.querySelector('[data-qqsr]');
  var qQup = root.querySelector('[data-qqup]');
  var qQdn = root.querySelector('[data-qqdn]');
  var viewBtns = root.querySelectorAll('[data-viewbtn]');
  /* Form qty before first add — always visible; Add puts this many in. Resets when the selected line changes. */
  var formWant = 1;
  var formWantVid = '';
  /* R3P-01: after Add, + slides under the finger. Hold it this long so a fast second tap is not a second add. */
  var qHoldUntil = 0;
  function qOff(btn, off){ if (!btn) return; btn.disabled = false; btn.setAttribute('aria-disabled', off ? 'true' : 'false'); }
  function quickInCart(vid){
    var st = ROWQ[vid], conf = CART_Q[vid] || 0;
    var pending = !!(st && st.opt !== null && (st.busy || st.opt !== conf));
    return { pending: pending, st: st, n: pending ? (st.opt !== null ? st.opt : conf) : (SESSION_VIDS[vid] ? conf : 0) };
  }

  function fillSelect(sel, values, placeholder, selected){
    if (!sel) return;
    var html = '<option value="">' + esc(placeholder) + '</option>';
    values.forEach(function(v){
      html += '<option value="' + esc(v) + '"' + (v === selected ? ' selected' : '') + '>' + esc(v) + '</option>';
    });
    sel.innerHTML = html;
  }
  /* D-7: the rail (fbrand, below) and this select are fed from the SAME sorted ROSTER; neither has its own list.
     R7H-01: brand-page Brand select = the rail's roster, never a new list or a new word (Themis
     R7H01-C1..C4): ROSTER only, A to Z, bare names, "All makers" last; placeholder stays "Brand". If ROSTER is empty or
     does not hold this page's maker, the select keeps today's single-option disabled state. */
  var BRAND_NAV = false, BRAND_HREF = {}, BRAND_ALL = '*all', brandArrowAt = 0, brandLeaving = false;
  function fillBrandRoster(){
    if (!qBrand || !BRAND_PAGE || !ROSTER.length) return false;
    var html = '', has = false;
    ROSTER.forEach(function(v){
      if (!v || !v.n || !v.h) return;
      BRAND_HREF[v.n] = v.h;
      if (v.n === BRAND_PAGE) has = true;
      html += '<option value="' + esc(v.n) + '"' + (v.n === BRAND_PAGE ? ' selected' : '') + '>' + esc(v.n) + '</option>';
    });
    if (!has) return false;
    qBrand.innerHTML = '<option value="" disabled>Brand</option>' + html +
      '<option value="' + BRAND_ALL + '">All makers</option>';
    return true;
  }
  function goBrand(){
    var v = qBrand.value;
    if (!v || v === BRAND_PAGE) return;
    var href = String((v === BRAND_ALL ? MASTER_URL : BRAND_HREF[v]) || '');
    /* Daedalus D-5: same-origin paths only, no query string, full-page load */
    if (href.charAt(0) !== '/' || href.charAt(1) === '/' || /[?#]/.test(href)){ qBrand.value = BRAND_PAGE; return; }
    brandLeaving = true;
    /* D-8: only the VIEW is remembered; the destination maker is never persisted (its page selects itself), and the
       last Brand/Flavour/Size is dropped so "All makers" opens the master Dropdown with nothing preselected. */
    try { localStorage.setItem(VIEW_KEY, 'form'); localStorage.removeItem(FORM_KEY); } catch(e){}
    window.location.assign(href);
  }
  function flavoursFor(brand){
    var seen = {}, out = [];
    IDX.forEach(function(r){
      if (r.b !== brand || !r.n || seen[r.n]) return;
      seen[r.n] = 1; out.push(r.n);
    });
    return out.sort(function(a,b){ return a.toLowerCase().localeCompare(b.toLowerCase()); });
  }
  function quickRow(){
    if (!qBrand || !qFlavour) return null;
    var b = qBrand.value, n = qFlavour.value;
    if (!b || !n) return null;
    for (var i = 0; i < IDX.length; i++){
      if (IDX[i].b === b && IDX[i].n === n) return IDX[i].el;
    }
    return null;
  }
  function quickChip(row){
    if (!row || !qSize || !qSize.value) return null;
    var want = qSize.value;
    var chips = row.querySelectorAll('[data-chip]');
    for (var i = 0; i < chips.length; i++){
      if ((chips[i].getAttribute('data-s') || '') === want) return chips[i];
    }
    return null;
  }
  function saveFormSel(){
    try {
      localStorage.setItem(FORM_KEY, JSON.stringify({
        b: qBrand ? qBrand.value : '',
        n: qFlavour ? qFlavour.value : '',
        s: qSize ? qSize.value : ''
      }));
    } catch(e){}
  }
  function loadFormSel(){
    try { return JSON.parse(localStorage.getItem(FORM_KEY) || '{}') || {}; }
    catch(e){ return {}; }
  }
  /* DD-NARROW (Orion 2026-10-05, Daedalus E1 / Themis DD-1): the card the plate has chosen carries data-ddpick; the
     section CSS draws the card's existing 2px inset ring on it in Dropdown view only. No colour, no badge, no scroll. */
  var ddPicked = null;
  function ddPick(row){
    if (ddPicked === row) return;
    if (ddPicked) ddPicked.removeAttribute('data-ddpick');
    ddPicked = row || null;
    if (ddPicked) ddPicked.setAttribute('data-ddpick', '');
  }
  function syncQuick(){
    if (!qAddBtn) return;
    var row = quickRow();
    var chip = quickChip(row);
    ddPick(row && chip ? row : null);
    if (row && chip){
      commit(row, chip);
      var money = chip.getAttribute('data-m') || '';
      var ident = rowIdent(row);
      if (qPrice){ qPrice.textContent = money; qPrice.setAttribute('data-empty', money ? '0' : '1'); }
      qAddBtn.disabled = false;
      if (qAddSr) qAddSr.textContent = 'Add ' + ident + ' to cart';
      var idEl = row.querySelector('[data-tpsb-id]');
      var vid = idEl ? String(idEl.value || '') : '';
      if (vid !== formWantVid){ formWantVid = vid; formWant = 1; }
      var qs = quickInCart(vid), st = qs.st, pending = qs.pending, n = qs.n;
      var max = rowMax(row);
      var inCart = n > 0;
      var show = inCart ? n : formWant;
      if (!inCart && max !== null && formWant > max) formWant = max;
      if (!inCart && formWant < 1) formWant = 1;
      show = inCart ? n : formWant;
      var capped = inCart
        ? ((max !== null && n >= max) || !!(st && st.capAt !== null && n >= st.capAt))
        : (max !== null && formWant >= max);
      if (qStep){
        qStep.setAttribute('data-mode', inCart ? 'cart' : 'want');
        qStep.setAttribute('aria-busy', pending ? 'true' : 'false');
      }
      if (qQn) qQn.textContent = String(show);
      if (qQsr) qQsr.textContent = inCart ? ('In cart, ' + n) : ('Quantity ' + formWant);
      if (qQup){
        qOff(qQup, !!capped || pending || (inCart && Date.now() < qHoldUntil));
        qQup.setAttribute('aria-label', inCart ? ('Add one more ' + ident) : ('Increase quantity for ' + ident));
      }
      if (qQdn){
        qOff(qQdn, pending || (inCart ? n <= 0 : formWant <= 1));
        qQdn.setAttribute('aria-label', inCart
          ? (n <= 1 ? ('Remove ' + ident + ' from cart') : ('Remove one ' + ident))
          : ('Decrease quantity for ' + ident));
      }
      /* In cart, Add is not drawn (CSS: [data-mode=cart] + .fbv2-qaddbtn); + adds one more, as on a grid card. */
      return;
    }
    formWantVid = '';
    if (formWant < 1) formWant = 1;
    var hint = !qBrand || !qBrand.value
      ? 'Select brand, flavour and size'
      : (!qFlavour || !qFlavour.value
        ? 'Select flavour and size'
        : 'Select size');
    if (qPrice){ qPrice.textContent = hint; qPrice.setAttribute('data-empty', '1'); }
    qAddBtn.disabled = true;
    if (qAddSr) qAddSr.textContent = hint;
    if (qStep){ qStep.setAttribute('data-mode', 'want'); qStep.setAttribute('aria-busy', 'false'); }
    if (qQn) qQn.textContent = String(formWant);
    if (qQsr) qQsr.textContent = 'Quantity ' + formWant;
    if (qQup){ qOff(qQup, false); qQup.setAttribute('aria-label', 'Increase quantity'); }
    if (qQdn){ qOff(qQdn, formWant <= 1); qQdn.setAttribute('aria-label', 'Decrease quantity'); }
  }
  function onBrandChange(preserve){
    if (!qBrand || !qFlavour || !qSize) return;
    var brand = qBrand.value;
    var keep = preserve || {};
    var flavours = brand ? flavoursFor(brand) : [];
    var pickF = (keep.n && flavours.indexOf(keep.n) >= 0) ? keep.n : '';
    fillSelect(qFlavour, flavours, 'Flavour', pickF);
    qFlavour.disabled = !brand;
    qSize.disabled = true;
    fillSelect(qSize, [], 'Size', '');
    if (pickF) onFlavourChange(keep);
    else { saveFormSel(); syncQuick(); }
    ddNarrow();
  }
  function onFlavourChange(preserve){
    if (!qBrand || !qFlavour || !qSize) return;
    var row = quickRow();
    var keep = preserve || {};
    var sizes = [];
    if (row){
      [].forEach.call(row.querySelectorAll('[data-chip]'), function(c){
        var s = c.getAttribute('data-s') || '';
        if (s && sizes.indexOf(s) < 0) sizes.push(s);
      });
      sizes.sort(function(a,b){
        var ga = grams(a), gb = grams(b);
        if (ga !== null && gb !== null) return ga - gb;
        return a.localeCompare(b);
      });
    }
    var pickS = (keep.s && sizes.indexOf(keep.s) >= 0) ? keep.s : (sizes[0] || '');
    fillSelect(qSize, sizes, 'Size', pickS);
    qSize.disabled = !sizes.length;
    saveFormSel();
    syncQuick();
  }
  function setView(mode, persist){
    var next = mode === 'form' ? 'form' : 'board';
    /* R7H-02: an explicit Grid/Dropdown press while the sheet is up is the user's own choice; Close must not undo it */
    if (persist !== false) sheetFromForm = false;
    root.setAttribute('data-view', next);
    [].forEach.call(viewBtns, function(btn){
      btn.setAttribute('aria-pressed', String(btn.getAttribute('data-viewbtn') === next));
    });
    if (next === 'form'){
      sheetFromForm = false;
      try { if (typeof setSheet === 'function') setSheet(false); } catch(e){}
      if (qBrand && !qBrand.options.length) fillSelect(qBrand, BRANDS, 'Brand', BRAND_PAGE || '');
      else if (qBrand && qBrand.options.length <= 1) fillSelect(qBrand, BRANDS, 'Brand', BRAND_PAGE || qBrand.value);
      if (BRAND_PAGE && qBrand){
        qBrand.value = BRAND_PAGE;
        qBrand.disabled = !BRAND_NAV;
      }
      var saved = loadFormSel();
      /* DD-NARROW: one brand state. Once the board's filter state exists (any toggle after load), the Brand select
         takes the Grid's brand filter: one maker -> that maker; none -> empty (full board); several -> the remembered
         maker if it is one of them, else empty. The remembered Flavour/Size survive only with their own maker. */
      if (!BRAND_PAGE && S){
        var gb = keys(S.brand);
        var nb = gb.length === 1 ? gb[0] : (gb.indexOf(saved.b) >= 0 ? saved.b : '');
        if (nb !== saved.b) saved = { b: nb };
      }
      if (BRAND_PAGE) saved.b = BRAND_PAGE;
      if (qBrand && !BRAND_PAGE){
        var ok = false;
        for (var i = 0; i < qBrand.options.length; i++){ if (qBrand.options[i].value === (saved.b || '')) ok = true; }
        qBrand.value = ok ? (saved.b || '') : '';
      }
      onBrandChange(saved);
    } else if (S) render();
    if (persist !== false){
      try { localStorage.setItem(VIEW_KEY, next); } catch(e){}
    }
    if (typeof syncBarVisibility === 'function') syncBarVisibility();
  }
  [].forEach.call(viewBtns, function(btn){
    btn.addEventListener('click', function(){ setView(btn.getAttribute('data-viewbtn'), true); });
  });
  /* R7H-01 (Orion 2026-10-05, founder P0): on a brand page this select was DISABLED, a dead end in Dropdown view.
     It now lists the same roster the Filter rail prints (same names, same collection URLs, then "All makers" to the
     master board), keeps the page's maker selected, and choosing another maker goes to that maker's page. The view
     key is written first so the next page opens in Dropdown view with its Flavour list filled.
     WCAG 3.2.2 / Daedalus D-6: navigation follows a COMMITTED choice only. A picker/pointer commit fires `change` on
     its own; an arrow key on a closed select (Chrome desktop, Windows) fires `change` in the same tick, so a change
     within 50 ms of an arrow key is NOT a commit: it waits for Enter, or for blur with the value still changed. */
  if (qBrand) qBrand.addEventListener('change', function(){
    if (BRAND_NAV){
      if (Date.now() - brandArrowAt < 50) return;
      goBrand();
      return;
    }
    onBrandChange({});
  });
  if (qBrand) qBrand.addEventListener('keydown', function(e){
    if (!BRAND_NAV) return;
    if (/^(Arrow|Page|Home|End)/.test(e.key)) brandArrowAt = Date.now();
    else if (e.key === 'Enter' && qBrand.value !== BRAND_PAGE){ e.preventDefault(); goBrand(); }
  });
  if (qBrand) qBrand.addEventListener('blur', function(){
    if (BRAND_NAV && !brandLeaving && qBrand.value && qBrand.value !== BRAND_PAGE) goBrand();
  });
  window.addEventListener('pageshow', function(e){
    if (e.persisted && BRAND_NAV && qBrand){ brandLeaving = false; qBrand.value = BRAND_PAGE; }
  });
  if (qFlavour) qFlavour.addEventListener('change', function(){ onFlavourChange({}); });
  if (qSize) qSize.addEventListener('change', function(){ saveFormSel(); syncQuick(); });
  if (qForm) qForm.addEventListener('submit', function(e){
    e.preventDefault(); e.stopPropagation();
    var row = quickRow(), chip = quickChip(row);
    if (!row || !chip) return;
    commit(row, chip);
    var idEl = row.querySelector('[data-tpsb-id]');
    var vid = idEl ? String(idEl.value || '') : '';
    /* R3P-01: decide "in cart" the way syncQuick() paints it, INCLUDING the optimistic figure of an add still in
       flight. The old test read CART_Q only, which fills ~1 s later, so a second tap inside that second was a second
       first-add and the queued flush sent qty 2. In cart, Add is not drawn and + is the only way to add more. */
    if (quickInCart(vid).n > 0) return;
    var was = document.activeElement;
    tapQty(row, Math.max(1, formWant), 'board-dropdown');
    qHoldUntil = Date.now() + 400;
    syncQuick();
    setTimeout(syncQuick, 420);
    /* Add just left the row under the focus; hand focus to the + that took its place (grid T-07). The page never goes inert. */
    if (was && was !== document.body && qForm.contains(was) && was.getClientRects().length === 0) fbv2Focus(qQup);
  });
    if (quickEl) quickEl.addEventListener('click', function(e){
    if (!e.target.closest) return;
    var up = e.target.closest('[data-qqup]');
    var dn = e.target.closest('[data-qqdn]');
    if (!up && !dn) return;
    var hit = up || dn;
    if (hit.disabled || hit.getAttribute('aria-disabled') === 'true') return;
    var row = quickRow();
    var n = 0, max = null;
    if (row){
      var idEl = row.querySelector('[data-tpsb-id]');
      var vid = idEl ? String(idEl.value || '') : '';
      n = quickInCart(vid).n;
      max = rowMax(row);
    }
    if (n > 0){
      tapQty(row, up ? 1 : -1, 'board-dropdown');
    } else {
      if (up){
        formWant = formWant + 1;
        if (max !== null && formWant > max) formWant = max;
      } else {
        formWant = Math.max(1, formWant - 1);
      }
    }
    syncQuick();
  });

  (function initView(){
    var saved = 'board';
    try {
      var v = localStorage.getItem(VIEW_KEY);
      if (v === 'form' || v === 'board') saved = v;
    } catch(e){}
    BRAND_NAV = fillBrandRoster();
    if (!BRAND_NAV) fillSelect(qBrand, BRANDS, 'Brand', BRAND_PAGE || '');
    if (BRAND_PAGE && qBrand) qBrand.disabled = !BRAND_NAV;
    setView(saved, false);
  })();

  /* ══════════════════ DRAWER SYNC ══════════════════
     Hand the returned sections to the THEME drawer so the header bubble and the drawer stay in
     sync; its auto-open is held off exactly as the add path always has.

     ★ WHY THIS IS NOT A try/catch ANY MORE (D16, 9 Sep).
     assets/cart.js renderContents() is:

         this.getSectionsToRender().forEach((section) => {
           const sectionElement = section.selector ? document.querySelector(section.selector)
                                                   : document.getElementById(section.id);
           sectionElement.innerHTML = this.getSectionInnerHTML(...);   // <- NO null check
         });
         ... then, AFTER the loop, the J-CART-1 fix re-derives `is-empty`.

     CartDrawer.getSectionsToRender() returns `{ id:"cart-icon-bubble" }` with NO selector, so that
     entry resolves through document.getElementById("cart-icon-bubble"). If that element is not on
     the page the assignment throws, the loop dies, and — because the `is-empty` re-derivation sits
     BELOW the loop — `is-empty` is NEVER re-derived. `.cart-drawer.is-empty .cart-drawer__footer
     { display:none }` then collapses the subtotal, the 18+/ID condition row and THE CHECKOUT
     BUTTON to 0x0. That is J-CART-1 exactly, reintroduced — and the old `catch(err){}` here made it
     SILENT: no throw, no log, no symptom until a customer cannot check out. A bare catch around
     cart state is not acceptable and is not what this does now.

     ESTABLISHED, not assumed: `id="cart-icon-bubble"` is rendered by snippets/header-cart.liquid,
     which snippets/header-inner.liquid renders in all three of its header layouts. Fetched from the
     rendered tobacco collection page on 9 Sep, it is present exactly once. So on the surface this
     section ships to, the node exists and the throw does not occur. That is a fact about TODAY'S
     header, not a property of the code — a header rework, a section-group change or a page that
     renders this board without the theme header would restore the defect in a form nobody sees.

     So the failure is made IMPOSSIBLE rather than invisible, in three parts, all of them here in
     our own file — assets/cart.js is not opened (Route A):

       1. PRE-FLIGHT. Every target in getSectionsToRender() is resolved BEFORE anything is written.
          If any node is absent we never enter the unguarded loop at all: we apply the sections that
          DO exist ourselves, node by node, and rebind the overlay that cart.js rebinds after its
          own loop (#CartDrawer-Overlay lives INSIDE #CartDrawer, so replacing that subtree drops
          its click handler). Order matters and is on our side: `cart-drawer` (selector #CartDrawer)
          is FIRST in the list and `cart-icon-bubble` second, so the drawer's own markup is fresh
          before anything could have gone wrong with the bubble.
       2. POST-FLIGHT INVARIANT. `is-empty` is re-asserted from the markup the SERVER just rendered
          — <cart-drawer-items class="is-empty"> — on EVERY path, in a `finally`, whether
          renderContents ran, threw, or was bypassed. This is the same rule cart.js uses and it is
          NOT the thing the note below forbids: it reads the rendered DOM, never the response body.
       3. OBSERVABLE. Anything unexpected increments a counter on window.__fbv2DrawerSync, writes
          console.error, and stamps data-fbv2-drawersync on the <cart-drawer> element, so the
          release gate can assert "renderContents proven not to throw" instead of hoping.

     ORIGINAL J-CART-1 NOTE, still binding: on the ADD path `resp` is the /cart/add.js reply — the
     added LINE ITEM. It carries NO `item_count` and NO `items`. A re-derivation of `is-empty` FROM
     THAT BODY evaluated "empty" on every successful add and re-asserted the class immediately after
     renderContents had cleared it, collapsing the footer and the checkout button. DO NOT re-derive
     `is-empty` from a response body that cannot answer the question. Re-deriving it from the
     server-rendered markup, as below, is the correct and only safe source. */
  var DSYNC = (window.__fbv2DrawerSync = { calls: 0, missing: [], threw: 0, repaired: 0, lastError: '' });

  function dsReport(kind, detail){
    DSYNC.lastError = kind + ': ' + detail;
    var d = document.querySelector('cart-drawer');
    if (d) d.setAttribute('data-fbv2-drawersync', DSYNC.lastError.slice(0, 180));
    if (window.console && console.error) console.error('[fbv2] drawerSync ' + kind, detail);
  }
  function dsTargets(drawer){
    var list = [];
    try { list = drawer.getSectionsToRender() || []; } catch(e){ list = []; }
    var outT = [];
    for (var i = 0; i < list.length; i++){
      var spec = list[i];
      outT.push({ spec: spec, sel: spec.selector || ('#' + spec.id),
        el: spec.selector ? document.querySelector(spec.selector) : document.getElementById(spec.id) });
    }
    return outT;
  }
  function dsInner(html, selector){
    if (typeof html !== 'string') return null;
    var node = null;
    try { node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector || '.shopify-section'); }
    catch(e){ return null; }
    return node ? node.innerHTML : null;
  }
  /* #CartDrawer-Overlay is a CHILD of #CartDrawer, so replacing that subtree destroys the
     click-to-close binding. cart.js rebinds it in the setTimeout after its own loop; when we
     have bypassed that loop we owe the same rebind. */
  function dsBindOverlay(drawer){
    var ov = drawer.querySelector('#CartDrawer-Overlay');
    if (ov && !ov.__fbv2Bound && typeof drawer.close === 'function'){
      ov.__fbv2Bound = true;
      ov.addEventListener('click', function(){ drawer.close(false); });
    }
  }
  /* THE INVARIANT. Derived from the markup the server rendered, never from the response body. */
  function dsAssertEmpty(drawer){
    var items = drawer.querySelector('cart-drawer-items');
    var rendersEmpty = items ? items.classList.contains('is-empty') : !drawer.querySelector('.cart-item');
    if (drawer.classList.contains('is-empty') !== rendersEmpty){
      drawer.classList.toggle('is-empty', rendersEmpty);
      DSYNC.repaired++;
      dsReport('repaired-is-empty', 'forced to ' + rendersEmpty);
    }
  }
  function drawerSync(resp){
    var drawer = document.querySelector('cart-drawer');
    if (!(resp && resp.sections && drawer && typeof drawer.renderContents === 'function')) return;
    DSYNC.calls++;

    var targets = dsTargets(drawer), missing = [];
    for (var i = 0; i < targets.length; i++){ if (!targets[i].el) missing.push(targets[i].sel); }

    /* Never nest stubs: overlapping adds used to capture the no-op as `held`
       and leave drawer.open permanently dead, so View cart stopped working. */
    var stubOpen = function(){};
    if (typeof drawer.__fbv2RealOpen !== 'function' || drawer.__fbv2RealOpen === stubOpen) {
      if (typeof drawer.open === 'function' && drawer.open !== stubOpen && !drawer.open.__fbv2Stub) {
        drawer.__fbv2RealOpen = drawer.open;
      }
    }
    var realOpen = drawer.__fbv2RealOpen;
    drawer.__fbv2OpenDepth = (drawer.__fbv2OpenDepth || 0) + 1;
    stubOpen.__fbv2Stub = true;
    drawer.open = stubOpen;
    try {
      if (missing.length){
        DSYNC.missing = missing;
        dsReport('missing-node', missing.join(' '));
        for (var j = 0; j < targets.length; j++){
          var t = targets[j];
          if (!t.el) continue;
          var inner = dsInner(resp.sections[t.spec.id], t.spec.selector);
          if (inner !== null) t.el.innerHTML = inner;
        }
        dsBindOverlay(drawer);
      } else {
        drawer.renderContents(resp);
      }
    } catch (err) {
      DSYNC.threw++;
      dsReport('threw', (err && err.message) || String(err));
    } finally {
      dsAssertEmpty(drawer);
      setTimeout(function(){
        drawer.__fbv2OpenDepth = Math.max(0, (drawer.__fbv2OpenDepth || 1) - 1);
        if (!drawer.__fbv2OpenDepth && realOpen) drawer.open = realOpen;
      }, 60);
    }
  }
  function tapQty(row, delta, src){
    var idEl = row.querySelector('[data-tpsb-id]'); if (!idEl) return;
    var vid = String(idEl.value || ''); if (!vid) return;
    var st = rowSt(vid), conf = CART_Q[vid] || 0;
    var from = st.opt !== null ? st.opt : conf;
    var next = Math.max(0, from + delta);
    var max = rowMax(row);
    if (delta > 0 && ((max !== null && next > max) || (st.capAt !== null && next > st.capAt))){
      /* at the cap (typically a line already in the cart from an earlier page, hidden at rest):
         reveal the figure with the + off, never a swallowed tap */
      if (conf > 0 && !SESSION_VIDS[vid]){ SESSION_VIDS[vid] = true; syncRow(row); }
      return;
    }
    if (next === from) return;
    SESSION_VIDS[vid] = true;
    st.opt = next;
    /* EXP-0002 stamp (assets/tps-src.js): which control asked for MORE. Read only on a confirmed increase below. */
    if (delta > 0) st.src = src || 'board-grid';
    syncRow(row);
    flushQty(row, vid);
  }
  function flushQty(row, vid){
    var st = rowSt(vid); if (st.busy) return;
    var conf = CART_Q[vid] || 0;
    if (st.opt === null || st.opt === conf){ st.opt = null; syncRow(row); return; }
    var target = st.opt, key = CART_K[vid], url, body;
    if (key){ url = '/cart/change.js'; body = { id: key, quantity: target }; }
    else if (target > 0){ url = '/cart/add.js'; body = { id: vid, quantity: target }; }
    else { st.opt = null; syncRow(row); return; }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function'){
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = (window.location && window.location.pathname) || '/';
    }
    st.busy = true;
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function(r){ return r.json().catch(function(){ return { status: r.status || 0 }; }); })
      .then(function(resp){
        if (resp && resp.status){
          /* refused. 422 = the stock cap: an existing line is revealed at its real figure with the
             + off; with no line to show, and on any other failure, the control returns to Add and
             the standing announcement runs. OPTIMISTIC MEANS WE SAID IT BEFORE IT WAS TRUE, so the
             failure path is the whole job — a UI that says "Added" over an item not in the cart is
             the same defect in a new hat. */
          if (resp.status === 422){ st.capAt = conf; if (conf > 0) SESSION_VIDS[vid] = true; else say('Not added.'); }
          else say('Not added.');
          st.opt = null;
          return refreshCart();
        }
        drawerSync(resp);
        var settled = (resp && resp.items) ? Promise.resolve(paintCart(resp)) : refreshCart();
        return settled.then(function(){
          var now = CART_Q[vid] || 0;
          if (st.opt === target && now !== target){ if (now < target) st.capAt = now; st.opt = null; }
          if (now > conf){
            say('In cart, ' + now);
            /* EXP-0002: one confirmed increase = one count for its source. Event only: no payload but the source word. */
            try { document.dispatchEvent(new CustomEvent('tps:src', { detail: st.src || 'board-grid' })); } catch(e){}
          }
          else if (now < conf) say(now > 0 ? ('In cart, ' + now) : ('Removed ' + rowIdent(row) + ' from cart'));
          if (!now) delete SESSION_VIDS[vid];
        });
      })
      .catch(function(){ say('Not added.'); st.opt = null; return refreshCart(); })
      .then(function(){
        st.busy = false;
        var now = CART_Q[vid] || 0;
        if (st.capAt !== null && now < st.capAt) st.capAt = null;
        if (!now) delete SESSION_VIDS[vid];
        if (st.opt !== null && st.opt !== now) flushQty(row, vid); else { st.opt = null; syncRow(row); }
        /* R3A-01: the dropdown panel painted "pending" while busy was true; repaint it now busy is false,
           on success and on refusal alike, or its − and + stay greyed with aria-busy=true. */
        syncQuick();
      });
  }

  /* ---------- forgiving search: token sets per card (tokens + joined pairs,
     digits split from letters so "love66" also yields "love" + "66") ---------- */
  function normText(s){
    return String(s || '').toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/([a-z])(\d)/g, '$1 $2').replace(/(\d)([a-z])/g, '$1 $2')
      .replace(/\s+/g, ' ').trim();
  }
  var ALIAS = { adalia:'adalya', adaliya:'adalya', adalja:'adalya',
    alfaker:'alfakher', alfakir:'alfakher', alfakhir:'alfakher',
    fakhir:'fakher', faker:'fakher',
    afzel:'afzal', afsal:'afzal',
    nakla:'nakhla', nachla:'nakhla',
    aladin:'aladdin', alladin:'aladdin',
    tangier:'tangiers', tanger:'tangiers',
    gibiar:'jibiar', zodiak:'zodiac', trifekta:'trifecta', starlin:'starline',
    azur:'azure', musthav:'musthave' };
  function tokq(s){
    return normText(s).split(' ').filter(Boolean).map(function(x){ return ALIAS[x] || x; });
  }
  function ed(a, b, cap){
    if (Math.abs(a.length - b.length) > cap) return cap + 1;
    var prev = [], cur = [], i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++){
      cur = [i]; var best = i;
      for (j = 1; j <= b.length; j++){
        var v = Math.min(prev[j] + 1, cur[j-1] + 1, prev[j-1] + (a.charCodeAt(i-1) === b.charCodeAt(j-1) ? 0 : 1));
        cur[j] = v; if (v < best) best = v;
      }
      if (best > cap) return cap + 1;
      prev = cur;
    }
    return prev[b.length];
  }
  function tokenHit(qt, tk){
    for (var i = 0; i < tk.length; i++){
      var w = tk[i];
      if (w === qt || w.indexOf(qt) === 0 || qt.indexOf(w) === 0) return true;
    }
    if (qt.length < 4) return false;
    var cap = qt.length >= 6 ? 2 : 1;
    for (var k = 0; k < tk.length; k++) if (ed(qt, tk[k], cap) <= cap) return true;
    return false;
  }
  function matchTokens(r, qt, requireAll){
    var hit = 0;
    for (var i = 0; i < qt.length; i++) if (tokenHit(qt[i], r.tk)) hit++;
    return requireAll ? hit === qt.length : hit > 0;
  }
  IDX.forEach(function(r){
    var t = normText(r.hay).split(' ').filter(Boolean);
    var tk = t.slice();
    for (var i = 0; i < t.length - 1; i++) tk.push(t[i] + t[i+1]);
    r.tk = tk;
    r.flat = normText(r.hay).replace(/ /g, '');
  });

  /* ---------- Panel fix #2: chips ascend by grams; every card defaults to its
     smallest in-stock size (non-size labels sort last). ---------- */
  /* R3P-22 (d′): the lane's data-n is the number of chips DRAWN (a size filter hides chips), never the product's
     variant count. drawBoard() takes the largest drawn count over the cards it shows and writes it ONCE on the
     board as data-szmax; the CSS reserve (Themis C1) keys on that one attribute, so every drawn card reserves
     together and nothing else carries the state. */
  function syncLane(sc){
    if (!sc) return 0;
    var n = 0, chips = sc.querySelectorAll('[data-chip]');
    for (var i = 0; i < chips.length; i++) if (!chips[i].hidden) n++;
    if (sc.getAttribute('data-n') !== String(n)) sc.setAttribute('data-n', String(n));
    return n;
  }

  IDX.forEach(function(r){
    var sc = r.el.querySelector('.fbv2-szs');
    var chips = [].slice.call(sc.querySelectorAll('[data-chip]'));
    if (chips.length >= 2){
      var sorted = chips.slice().sort(function(a,b){
        var ga = grams(a.getAttribute('data-s')), gb = grams(b.getAttribute('data-s'));
        return (ga===null?1e9:ga) - (gb===null?1e9:gb);
      });
      if (sorted.some(function(c,i){ return c !== chips[i]; })) sorted.forEach(function(c){ sc.appendChild(c); });
      r.chips = sorted;
      r.cents = sorted.map(function(c){ return parseInt(c.getAttribute('data-c') || '0', 10) || 0; });
      var first = sorted[0];
      if (first && first.tagName === 'BUTTON' && first.getAttribute('aria-pressed') !== 'true') commit(r.el, first);
    } else {
      r.chips = chips;
      r.cents = chips.map(function(c){ return parseInt(c.getAttribute('data-c') || '0', 10) || 0; });
    }
    syncLane(sc);
  });

  /* ══════════════════════════════════════════════════════════════════════════
     THE FILTER STATE. Filtering is HIDING an already-rendered card, never
     rebuilding the board and never writing innerHTML into it. Out-of-stock
     exclusion is Liquid's job and happened before this script existed.
     ══════════════════════════════════════════════════════════════════════════ */
  var S = { q:'', size:{}, brand:{}, lo:0, hi:0 };
  var sizeCount = 0, brandCount = 0;
  var PMIN = 0, PMAX = 0, DLO = 0, DHI = 0, AVAIL = [], PTOUCH = false;
  (function priceDomain(){
    var lo = Infinity, hi = -Infinity;
    IDX.forEach(function(r){ r.cents.forEach(function(c){ if (c < lo) lo = c; if (c > hi) hi = c; }); });
    if (!isFinite(lo)){ lo = 0; hi = 0; }
    PMIN = lo; PMAX = hi; DLO = lo; DHI = hi; S.lo = lo; S.hi = hi;
  })();
  if (BRAND_PAGE){ S.brand[BRAND_PAGE] = 1; brandCount = 1; }

  /* ---- the search ladder. The shelf is never empty and nothing is ever said
     about what is not there. Four rungs, first non-empty wins; if none do, the
     customer stands in front of the whole board. ---- */
  function searchSet(){
    var raw = S.q.trim();
    if (!raw) return IDX;
    var qt = tokq(raw);
    if (!qt.length) return IDX;
    var joined = normText(raw).replace(/ /g, '');
    var r = IDX.filter(function(x){ return x.flat.indexOf(joined) >= 0; });
    if (r.length) return r;
    r = IDX.filter(function(x){ return matchTokens(x, qt, true); });
    if (r.length) return r;
    r = IDX.filter(function(x){ return matchTokens(x, qt, false); });
    if (r.length) return r;
    return IDX;
  }
  function passItem(r, skip){
    if (skip !== 'brand' && brandCount && !S.brand[r.b]) return false;
    return true;
  }
  function chipPasses(r, i, skip){
    if (skip !== 'size' && sizeCount){
      if (!S.size[r.chips[i].getAttribute('data-s') || '']) return false;
    }
    if (skip !== 'price' && PTOUCH){
      var c = r.cents[i];
      if (c < S.lo || c > S.hi) return false;
    }
    return true;
  }
  /* compute(skip) — the cards, and which of their chips survive, ignoring one axis. */
  function compute(skip){
    var base = searchSet(), out = [];
    for (var i = 0; i < base.length; i++){
      var r = base[i];
      if (!passItem(r, skip)) continue;
      var keep = [];
      for (var j = 0; j < r.chips.length; j++) if (chipPasses(r, j, skip)) keep.push(j);
      if (keep.length) out.push({ r: r, keep: keep });
    }
    return out;
  }

  /* ══ THE BOARD CANNOT BE MADE EMPTY. Most brands stock one or two sizes, so
     most brand x size pairs describe nothing in the real catalogue — and we are
     forbidden from explaining an empty result, because "no results for X in
     100g" narrates an absence. So the empty result is made UNREACHABLE instead
     of explained. Three mechanisms, all silent, all removal and never greying:
       1 a rail chip whose value would return nothing is NOT RENDERED;
       2 a chosen chip that has become impossible is dropped from the selection,
         silently, before the plate is drawn;
       3 the price range's DOMAIN is clamped to the prices actually present in
         the current set, and each thumb SNAPS to a price that is actually
         there — so the two numerals always name real board prices and the
         window always contains at least one of them.
     Mechanism 3 is what makes this a proof rather than a hope: after
     reconcile(), S.lo is a member of AVAIL, and AVAIL is the price list of the
     variants that already pass search + brand + size. At least one variant
     therefore passes every filter at once, so compute(null) cannot be empty. ══ */
  function availPrices(){
    var seen = {}, out = [];
    compute('price').forEach(function(e){
      e.keep.forEach(function(j){ var c = e.r.cents[j]; if (!seen[c]){ seen[c] = 1; out.push(c); } });
    });
    return out.sort(function(a,b){ return a - b; });
  }
  function reconcile(){
    for (var pass = 0; pass < 8; pass++){
      var ch = false;
      AVAIL = availPrices();
      if (AVAIL.length){
        var lo = AVAIL[0], hi = AVAIL[AVAIL.length - 1];
        if (lo !== DLO || hi !== DHI){ DLO = lo; DHI = hi; ch = true; }
        if (!PTOUCH){
          if (S.lo !== DLO || S.hi !== DHI){ S.lo = DLO; S.hi = DHI; ch = true; }
        } else {
          /* R4A-01 (Orion 2026-10-04): the thumbs used to snap to the NEAREST price, which could loosen the
             window the shopper set ($100 floor -> $90, and $90 items showed). The floor now snaps UP to the
             first price at or above it and the ceiling DOWN to the last price at or below it, so a snapped
             window is always inside the one the shopper asked for. Only when no price lies inside that
             window at all (floor above the ceiling after snapping) do both thumbs meet on the one nearest
             price, which is the proof mechanism 3 needs: S.lo is a member of AVAIL either way. */
          var a = null, b = null, i;
          for (i = 0; i < AVAIL.length; i++){ if (AVAIL[i] >= S.lo){ a = AVAIL[i]; break; } }
          for (i = AVAIL.length - 1; i >= 0; i--){ if (AVAIL[i] <= S.hi){ b = AVAIL[i]; break; } }
          if (a === null || b === null || a > b){
            var mid = (S.lo + S.hi) / 2;
            a = b = AVAIL.reduce(function(p,q){ return Math.abs(q-mid) < Math.abs(p-mid) ? q : p; });
          }
          if (a !== S.lo || b !== S.hi){ S.lo = a; S.hi = b; ch = true; }
        }
      }
      var av = {};
      compute('size').forEach(function(e){
        e.keep.forEach(function(j){
          var l = e.r.chips[j].getAttribute('data-s') || '';
          if (grams(l) !== null) av[l] = 1;
        });
      });
      keys(S.size).forEach(function(k){ if (!av[k]){ delete S.size[k]; sizeCount--; ch = true; } });
      var ab = {};
      compute('brand').forEach(function(e){ ab[e.r.b] = 1; });
      /* on a brand page the page's own vendor IS the board; it is never let go */
      keys(S.brand).forEach(function(k){
        if (!ab[k] && k !== BRAND_PAGE){ delete S.brand[k]; brandCount--; ch = true; }
      });
      if (!ch) break;
    }
    /* seatbelt: if anything ever survived the loop empty, the customer is put back in front of the
       whole board — silently, exactly as the search ladder does. */
    if (!compute(null).length){
      S.size = {}; sizeCount = 0;
      S.brand = {}; brandCount = 0;
      if (BRAND_PAGE){ S.brand[BRAND_PAGE] = 1; brandCount = 1; }
      PTOUCH = false;
      AVAIL = availPrices();
      DLO = AVAIL.length ? AVAIL[0] : PMIN; DHI = AVAIL.length ? AVAIL[AVAIL.length-1] : PMAX;
      S.lo = DLO; S.hi = DHI;
    }
    if (PLO && PHI){
      PLO.min = DLO; PLO.max = DHI; PHI.min = DLO; PHI.max = DHI;
      PLO.value = S.lo; PHI.value = S.hi;
    }
  }

  /* ---- draw the plate: reveal what survives, hide what does not. No card is
     created or destroyed and no innerHTML is written into the board. ---- */
  function drawBoard(res){
    var live = {}, szmax = 0, szfree = 0;
    for (var i = 0; i < IDX.length; i++) IDX[i].pos = i;
    res.forEach(function(e){
      var r = e.r, keepSet = {};
      e.keep.forEach(function(j){ keepSet[j] = 1; });
      live[r.pos] = 1;
      r.el.hidden = false;
      var chosen = -1, firstVisible = -1;
      for (var j = 0; j < r.chips.length; j++){
        var c = r.chips[j], on = !!keepSet[j];
        c.hidden = !on;
        if (on){
          if (firstVisible < 0) firstVisible = j;
          if (c.hasAttribute('data-free')) szfree = 1;
          if (c.getAttribute('aria-pressed') === 'true' || c.hasAttribute('data-solo')) chosen = j;
        }
      }
      /* a chip a filter has removed is silently replaced by the first chip that
         survived — no message, no greyed option, nothing said about what is not
         there. The price in the foot follows the chip, as it always does. */
      if (chosen < 0 && firstVisible >= 0){
        var f = r.chips[firstVisible];
        if (f.tagName === 'BUTTON') commit(r.el, f);
      }
      szmax = Math.max(szmax, syncLane(r.el.querySelector('.fbv2-szs')));
    });
    IDX.forEach(function(r){ if (!live[r.pos]) r.el.hidden = true; });
    var szm = String(Math.min(szmax, 6));
    if (boardEl && boardEl.getAttribute('data-szmax') !== szm) boardEl.setAttribute('data-szmax', szm);
    if (boardEl && boardEl.getAttribute('data-szfree') !== String(szfree)) boardEl.setAttribute('data-szfree', String(szfree));
  }

  /* ---- rail rendering. NO COUNTS. A chip is a label and nothing else.
     Options that would return nothing are removed, silently. ---- */
  function opt(kind, val, label, on, box){
    return '<button class="fbv2-opt" type="button" data-k="' + kind + '" data-v="' + esc(val) + '"' +
      ' aria-pressed="' + (on ? 'true' : 'false') + '">' +
      '<span class="k">' + (box ? '<span class="bx"></span>' : '') + '<span>' + esc(label) + '</span></span>' +
      '</button>';
  }
  function drawRails(){
    var sizeRes = compute('size'), brandRes = compute('brand');
    var cs = {}, cbr = {};
    sizeRes.forEach(function(e){
      e.keep.forEach(function(j){
        var l = e.r.chips[j].getAttribute('data-s') || '';
        if (grams(l) !== null) cs[l] = 1;
      });
    });
    brandRes.forEach(function(e){ cbr[e.r.b] = 1; });

    if (fsize) fsize.innerHTML = SIZES.filter(function(s){ return cs[s] || S.size[s]; })
      .map(function(s){ return opt('size', s, s, !!S.size[s], false); }).join('');

    if (fbrand){
      if (BRAND_PAGE && ROSTER.length){
        /* on a brand page every OTHER maker is a link to its own collection, so the whole roster
           stays reachable. The page's own maker is marked current, not pressable. */
        fbrand.innerHTML = ROSTER.map(function(v){
          if (v.n === BRAND_PAGE){
            return '<span class="fbv2-opt" aria-current="true"><span class="k"><span class="bx"></span>' +
              '<span>' + esc(v.n) + '</span></span></span>';
          }
          return '<a class="fbv2-opt" href="' + esc(v.h) + '"><span class="k"><span class="bx"></span>' +
            '<span>' + esc(v.n) + '</span></span></a>';
        }).join('') +
        '<a class="fbv2-opt" href="' + esc(MASTER_URL) + '"><span class="k"><span class="bx"></span>' +
        '<span>All makers</span></span></a>';
      } else {
        fbrand.innerHTML = BRANDS.filter(function(b){ return cbr[b] || S.brand[b]; })
          .map(function(b){ return opt('brand', b, b, !!S.brand[b], true); }).join('');
      }
    }
  }

  /* ---- the price readout. The two numerals label the FILTER'S window.
     CARRIED CONDITION OF THE 9 Sep RULING: when the endpoints coincide the
     readout collapses to ONE numeral — "$180", never "$180 to $180". ---- */
  function paintRange(){
    if (!psel) return;
    var span = (DHI - DLO) || 1;
    psel.style.setProperty('--a', (S.lo - DLO) / span);
    psel.style.setProperty('--b', (S.hi - DLO) / span);
    var one = S.lo === S.hi;
    if (plab) plab.textContent = money(S.lo);
    if (phlab){ phlab.textContent = money(S.hi); phlab.hidden = one; }
    if (pto) pto.hidden = one;
    if (pread) pread.classList.toggle('is-one', one);
  }
  /* Is the customer looking at a NARROWED board? A brand page's own preselected
     brand is not a filter he applied — it is the page — so it never counts, in
     either control. */
  function filtersApplied(){
    var brandsApplied = BRAND_PAGE ? false : brandCount > 0;
    return !!(sizeCount || brandsApplied || S.lo > DLO || S.hi < DHI || S.q.trim());
  }
  function syncClear(){
    if (!clearBtn) return;
    /* LEFT AS IT WAS, DELIBERATELY. The rail's control ignores the search box
       (the search has its own X in the masthead), and changing that would change
       a shipped control nobody asked about. The end-of-list chip below DOES
       count the search, because at the bottom of a searched list "clear the
       filters" is the move the customer wants and the search is one of them.
       Both fire clearAll(), so the ACTION is identical either way. Flagged in
       the handover rather than fixed here. */
    var brandsApplied = BRAND_PAGE ? false : brandCount > 0;
    clearBtn.hidden = !(sizeCount || brandsApplied || S.lo > DLO || S.hi < DHI);
  }
  /* THE END OF THE LIST. Exactly one of these can be visible, and on the master
     shelf with nothing applied neither is — the wrapper collapses to zero height
     and the page ends as it does today. Nothing is announced: a live region here
     would narrate the state of the list, which is the thing this surface does
     not do. These are controls, and a control speaks when it is used. */
  function syncEol(){
    var filtered = filtersApplied();
    if (eolClear) eolClear.hidden = !filtered;
    if (eolRoute) eolRoute.hidden = filtered;
  }

  /* T7 (R3P-12): after a pick the board said nothing. The Filter button now carries how many filters are ON (the
     customer's own choices: each brand, each size, a moved price window; the search has its own X and is not
     counted), and the open sheet's foot carries the one clear and the button back to the board. */
  function filterOnCount(){
    return sizeCount + (BRAND_PAGE ? 0 : brandCount) + ((S.lo > DLO || S.hi < DHI) ? 1 : 0);
  }
  function syncFilterState(){
    var n = filterOnCount();
    var open = pageEl && pageEl.getAttribute('data-sheet') === '1';
    if (fbtn){
      fbtn.textContent = open ? copy('close') : (n ? copy('filterOn', n) : copy('filter'));
      fbtn.setAttribute('data-on', n ? '1' : '0');
    }
    if (sheetClear) sheetClear.hidden = !n;
    if (sheetShow) sheetShow.textContent = copy('show');
  }
  /* DD-NARROW (Orion 2026-10-05; Daedalus E1 item 5, Themis DD-1/DD-5): in Dropdown view the board below the plate
     is narrowed by the BRAND axis only, through the same S.brand state the Grid rail writes, so Grid shows the same
     maker pressed. Search, size and price are Grid controls and are not applied here: every displayed maker's card
     shows every price row it has. They are kept, untouched, and apply again the moment Grid is pressed. */
  function isForm(){ return root.getAttribute('data-view') === 'form'; }
  function computeForm(){
    var out = [];
    IDX.forEach(function(r){
      if (!passItem(r, null)) return;
      out.push({ r: r, keep: r.chips.map(function(c, j){ return j; }) });
    });
    return out;
  }
  function ddNarrow(){
    /* S is declared below the plate code; the first call (initView, before the filter state exists) is a no-op and
       the boot's own render() picks the plate's brand up. */
    if (!S || !isForm()) return;
    if (!BRAND_PAGE && qBrand){
      var b = qBrand.value || '';
      var cur = keys(S.brand);
      if (!(cur.length === (b ? 1 : 0) && (!b || S.brand[b]))){
        S.brand = {}; brandCount = 0;
        if (b){ S.brand[b] = 1; brandCount = 1; }
      }
    }
    /* the search box sits in the mast in both views; the Dropdown board does not apply it, so it is emptied rather
       than left showing words the board is not following (same reset as its own X) */
    if (S.q){ S.q = ''; if (srch) srch.value = ''; if (qclr) qclr.hidden = true; }
    render();
  }
  function render(){
    /* reconcile() is the Grid's proof that no filter combination is empty; the Dropdown board is brand-only and can
       never be empty (the select lists only makers with rendered cards), so it is not run there */
    if (!isForm()) reconcile();
    drawBoard(isForm() ? computeForm() : compute(null));
    drawRails(); paintRange(); syncClear(); syncEol(); syncFilterState(); writeURL();
  }

  /* ---------- the URL: merge, never clobber (view= and preview_theme_id= survive) ---------- */
  function writeURL(){
    try {
      var p = new URLSearchParams(location.search);
      if (S.q.trim()) p.set('q', S.q.trim()); else p.delete('q');
      var bk = keys(S.brand).filter(function(b){ return b !== BRAND_PAGE; });
      if (bk.length === 1) p.set('brand', slug(bk[0])); else p.delete('brand');
      var zk = keys(S.size);
      if (zk.length === 1) p.set('size', zk[0]); else p.delete('size');
      var s = p.toString();
      history.replaceState(null, '', location.pathname + (s ? '?' + s : ''));
    } catch(e){}
  }
  (function readURL(){
    try {
      var p = new URLSearchParams(location.search);
      var q = p.get('q'); if (q){ S.q = q; if (srch) srch.value = q; }
      var s = p.get('size'); if (s) SIZES.forEach(function(x){ if (x === s && !S.size[x]){ S.size[x] = 1; sizeCount++; } });
      var b = p.get('brand'); if (b && !BRAND_PAGE) BRANDS.forEach(function(x){ if (slug(x) === b && !S.brand[x]){ S.brand[x] = 1; brandCount++; } });
    } catch(e){}
  })();

  /* ---------- events ---------- */
  boardEl.addEventListener('click', function(e){
    if (!e.target.closest) return;
    var chip = e.target.closest('[data-chip]');
    if (chip && chip.tagName === 'BUTTON'){
      var row = chip.closest('[data-row]');
      if (row) commit(row, chip);
      return;
    }
    var up = e.target.closest('[data-qup]');
    if (up){
      if (up.disabled) return;
      var r2 = up.closest('[data-row]');
      if (r2){
        tapQty(r2, 1);
        /* T-07: + reached the cap and went disabled under the focus -> the minus keeps it */
        if (up.disabled && document.activeElement !== up) fbv2Focus(r2.querySelector('[data-qdn]:not([disabled])'));
      }
      return;
    }
    var dn = e.target.closest('[data-qdn]');
    if (dn){
      if (dn.disabled) return;
      var r3 = dn.closest('[data-row]');
      if (r3){
        tapQty(r3, -1);
        /* T-07: last Remove -> the stepper is hidden and Add is back; focus the restored Add */
        var act3 = r3.querySelector('[data-add]');
        if (act3 && act3.getAttribute('data-qty') === '0') fbv2Focus(r3.querySelector('[data-addbtn]'));
      }
    }
  });
  /* the card's own submit (the whole tile, and Enter on the control) is handled HERE and never
     reaches the shared add handler on document: taps must queue per variant, and that handler
     drops a tap while one is in flight. It is the ATTRIBUTE that keeps the shared handler off
     this form (it binds form[data-tps-board-atc]; these forms carry data-fbv2add) — NOT the
     stopPropagation below, which is powerless against a capture-phase listener on document that
     has already run. See the double-add note in this file's header. */
  boardEl.addEventListener('submit', function(e){
    var f = e.target && e.target.closest ? e.target.closest('form[data-fbv2add]') : null;
    if (!f) return;
    e.preventDefault(); e.stopPropagation();
    var row = f.closest('[data-row]');
    if (row){
      var was = document.activeElement;
      tapQty(row, 1);
      /* T-07: Enter on Add swapped it for the stepper; focus the + (Tiresias's spec) so Tab continues from this card.
         Orion (Tiresias re-verify, 2026-10-03): the former guard read document.activeElement here, but Chromium only
         moves focus off the now display:none Add in its focus-fixup step AFTER this handler returns, so the test was
         false at this instant and fbv2Focus never ran. Decide from `was` instead: the focused control was inside this
         row and has no box any more. */
      var act = row.querySelector('[data-add]');
      if (act && act.getAttribute('data-qty') !== '0' && was && was !== document.body && row.contains(was) && was.getClientRects().length === 0){
        fbv2Focus(row.querySelector('[data-qup]:not([disabled])') || row.querySelector('[data-qdn]:not([disabled])'));
      }
    }
  });

  if (pageEl) pageEl.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('.fbv2-opt[data-k]') : null;
    if (!b) return;
    var kind = b.getAttribute('data-k'), v = b.getAttribute('data-v');
    var set = kind === 'size' ? S.size : S.brand;
    if (set[v]){ delete set[v]; if (kind === 'size') sizeCount--; else brandCount--; }
    else { set[v] = 1; if (kind === 'size') sizeCount++; else brandCount++; }
    var hadFocus = document.activeElement === b;
    render();
    /* R4T-03 (Tiresias, Orion 2026-10-04): render() -> drawRails() rebuilds the rail, so the pressed option was a new
       element and focus fell to BODY with nothing said. The same option (data-k + data-v) takes focus again; if the
       pick dropped it (an option that would now return nothing is not rendered), the rail's first option does, then
       the Filter button. The live region says what the Filter button now reads: the signed "Filter · {n}" / "Filter". */
    if (hadFocus){
      var again = pageEl.querySelector('.fbv2-opt[data-k="' + kind + '"][data-v="' + (window.CSS && CSS.escape ? CSS.escape(v) : v.replace(/"/g, '\\"')) + '"]');
      fbv2Focus(again || pageEl.querySelector('.fbv2-opt[data-k="' + kind + '"]') || fbtn);
    }
    var fn = filterOnCount();
    say(fn ? copy('filterOn', fn) : copy('filter'));
  });
  /* ONE clear, TWO buttons. This was the rail button's inline handler, lifted
     verbatim into a named function so the end-of-list chip runs the SAME reset
     rather than a second copy that can drift from it. Body unchanged. */
  function clearAll(){
    S.q = ''; if (srch) srch.value = ''; if (qclr) qclr.hidden = true;
    S.size = {}; sizeCount = 0;
    S.brand = {}; brandCount = 0;
    if (BRAND_PAGE){ S.brand[BRAND_PAGE] = 1; brandCount = 1; }
    PTOUCH = false; DLO = PMIN; DHI = PMAX; S.lo = PMIN; S.hi = PMAX;
    render();
  }
  if (clearBtn) clearBtn.addEventListener('click', function(){ clearAll(); });
  if (eolClear) eolClear.addEventListener('click', function(){
    clearAll();
    /* This button has just hidden itself, so focus would fall to <body> and a
       keyboard user would restart the page's tab order from the top. Hand focus
       to whatever took its place in the same wrapper (the route chip, on a
       sub-shelf), and otherwise to the plate, which is where "show me all of it"
       actually points. preventScroll keeps the viewport where the customer left
       it — the list only got longer beneath him, so there is nothing to jump to.
       The board is only made focusable at this moment; it never becomes a tab
       stop for anyone who has not pressed this. */
    var next = (eolRoute && !eolRoute.hidden) ? eolRoute : boardEl;
    if (!next) return;
    if (next === boardEl) boardEl.setAttribute('tabindex', '-1');
    try { next.focus({ preventScroll: true }); } catch(e){ next.focus(); }
  });

  function onRange(){
    PTOUCH = true;
    var lo = +PLO.value, hi = +PHI.value;
    if (lo > hi){
      if (document.activeElement === PLO){ hi = lo; PHI.value = hi; }
      else { lo = hi; PLO.value = lo; }
    }
    S.lo = lo; S.hi = hi; render();
  }
  if (PLO && PHI){ PLO.addEventListener('input', onRange); PHI.addEventListener('input', onRange); }

  /* iOS native search-clear fires `search`/`change`, not `input` — bind all three. */
  if (srch){
    ['input','search','change'].forEach(function(ev){
      srch.addEventListener(ev, function(){
        if (srch.value === S.q) return;
        /* R3A-15: Search stays in the mast in Dropdown view; a search is a Grid action, so the board comes back */
        if (root.getAttribute('data-view') === 'form') setView('board', true);
        S.q = srch.value; if (qclr) qclr.hidden = !srch.value; render();
      });
    });
    srch.addEventListener('keydown', function(e){ if (e.key === 'Enter') e.preventDefault(); });
    if (qclr){
      qclr.hidden = !srch.value;
      qclr.addEventListener('click', function(){
        srch.value = ''; S.q = ''; qclr.hidden = true; render(); srch.focus();
      });
    }
  }
  /* below 900 the two rails become one sheet; on desktop this button is not drawn.
     Opening used to blank the board via display:none without scrolling, so a user
     who had scrolled down saw an empty viewport and the IntersectionObserver hid
     the cart bar. Scroll the page into view and keep the bar while the sheet is up. */
  /* Orion pass 2 (Argus S-07): scrollIntoView put the sheet's top at viewport 0, UNDER the fixed band and the sticky
     mast (390: band 0-51, mast 51-168), so Adalya, Afzal and Al Fakher were covered and a tap on "Al Fakher" hit the
     GRID/DROPDOWN switch. Land the page's top exactly under whatever is fixed above it. T4 (2026-10-04): in a short
     landscape viewport the mast no longer sticks, so only the band is above it. */
  function landPage(){
    var mastEl = root.querySelector('.fbv2-mast');
    var stuckAt = parseFloat(getComputedStyle(root).getPropertyValue('--fbv2-band')) || 0;
    if (mastEl){
      var mcs = getComputedStyle(mastEl);
      if (mcs.position === 'sticky') stuckAt = (parseFloat(mcs.top) || 0) + mastEl.getBoundingClientRect().height;
    }
    window.scrollTo({ top: Math.max(0, pageEl.getBoundingClientRect().top + window.pageYOffset - stuckAt), behavior: 'instant' });
  }
  var sheetFromForm = false;
  function setSheet(wantOpen){
    var was = pageEl.getAttribute('data-sheet') === '1';
    pageEl.setAttribute('data-sheet', wantOpen ? '1' : '0');
    if (fbtn) fbtn.setAttribute('aria-expanded', String(!!wantOpen));
    /* R4T-07: the open sheet is a dialog named by the signed word; closed, the attributes come off */
    if (wantOpen){ pageEl.setAttribute('role', 'dialog'); pageEl.setAttribute('aria-modal', 'true'); pageEl.setAttribute('aria-label', copy('filter')); }
    else { pageEl.removeAttribute('role'); pageEl.removeAttribute('aria-modal'); pageEl.removeAttribute('aria-label'); }
    syncFilterState();
    if (wantOpen){
      landPage();
      if (typeof syncBarVisibility === 'function') syncBarVisibility();
      var first = pageEl.querySelector('.fbv2-rail [data-opt], .fbv2-rail button, .fbv2-rail a');
      if (first && typeof first.focus === 'function'){ try { first.focus({ preventScroll: true }); } catch (e2) { first.focus(); } }
    } else {
      /* T7: closing from the foot (or from the mast) lands on the TOP of the results, not wherever the sheet's
         scroll left the page. Only when the sheet was actually open: setView() closes it on every switch. */
      if (was && sheetFromForm){ sheetFromForm = false; setView('form', false); }
      if (was) landPage();
      if (typeof syncBarVisibility === 'function') syncBarVisibility();
      /* focus returns to Filter only when a sheet actually closed: setView() calls this on every switch, and since
         R3A-15 Filter is visible in Dropdown view, so an unconditional focus would pull focus off the toggle */
      if (was && fbtn) {
        try { fbtn.focus({ preventScroll: true }); } catch (e3) { fbtn.focus(); }
      }
    }
  }
  if (fbtn) fbtn.addEventListener('click', function(){
    /* R3A-15: Filter stays in the mast in Dropdown view; filters act on the board, so the board comes back first */
    /* R7H-02 (Orion 2026-10-05): this used to flip the remembered view to Grid for good, so closing the sheet (or
       following a maker link on a brand page) left Dropdown silently. Now the sheet opens over a TEMPORARY Grid: Close /
       Escape go back to Dropdown; "Show results" is the explicit choice of the Grid and is remembered. */
    if (root.getAttribute('data-view') === 'form'){ setView('board', false); sheetFromForm = true; setSheet(true); return; }
    setSheet(pageEl.getAttribute('data-sheet') !== '1');
  });
  if (sheetShow) sheetShow.addEventListener('click', function(){
    if (sheetFromForm){ sheetFromForm = false; try { localStorage.setItem(VIEW_KEY, 'board'); } catch(e){} }
    setSheet(false);
  });
  if (sheetClear) sheetClear.addEventListener('click', function(){
    clearAll();
    /* it has just hidden itself; keep focus in the foot */
    try { sheetShow.focus({ preventScroll: true }); } catch(e){ if (sheetShow) sheetShow.focus(); }
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    if (pageEl.getAttribute('data-sheet') !== '1') return;
    e.preventDefault();
    setSheet(false);
  });

  /* ---------- the bar + Form receipt: ONE cart total, outside the tobacco cage ---------- */
  function syncBarVisibility(){
    if (!barEl) return;
    var hasItems = viewBtn && !viewBtn.disabled;
    if (!hasItems){ barEl.hidden = true; return; }
    /* Form view and the mobile filter sheet: keep View cart + total reachable.
       Board view: retire the bar only after the price list has left the viewport
       so it does not cover the theme footer. */
    if (root.getAttribute('data-view') === 'form' || (pageEl && pageEl.getAttribute('data-sheet') === '1')){
      barEl.hidden = false;
      return;
    }
    barEl.hidden = !PAGE_IN_VIEW;
  }
  function paintReceipt(cart){
    if (!receiptEl || !receiptList) return;
    var items = (cart && cart.items) || [];
    var n = cart && cart.item_count || 0;
    receiptEl.hidden = false;
    receiptEl.setAttribute('data-empty', n ? '0' : '1');
    if (!n){
      receiptList.innerHTML = '';
      if (receiptTot) receiptTot.textContent = '';
      return;
    }
    receiptList.innerHTML = items.map(function(i){
      var title = i.product_title || i.title || 'Item';
      var vt = i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '';
      var qty = i.quantity || 0;
      var line = typeof i.final_line_price === 'number' ? i.final_line_price
        : (typeof i.line_price === 'number' ? i.line_price : 0);
      var meta = (vt ? esc(vt) + ' · ' : '') + '×' + qty;
      return '<li><span class="nm">' + esc(title) +
        '<span class="meta">' + meta + '</span></span>' +
        '<span class="ln">' + money(line) + '</span></li>';
    }).join('');
    if (receiptTot) receiptTot.textContent = money(cart.total_price || 0);
  }

  function paintCart(cart){
    if (!cart) return;
    var n = cart.item_count || 0, tot = cart.total_price || 0;
    if (cartt) cartt.textContent = n ? money(tot) : '';
    if (viewBtn) viewBtn.disabled = !n;
    CART_Q = {}; CART_K = {};
    (cart.items || []).forEach(function(i){
      var k = String(i.variant_id || i.id || '');
      CART_Q[k] = (CART_Q[k] || 0) + (i.quantity || 0);
      if (!CART_K[k] && i.key) CART_K[k] = i.key;
    });
    for (var v in SESSION_VIDS){ if (SESSION_VIDS.hasOwnProperty(v) && !CART_Q[v]) delete SESSION_VIDS[v]; }
    syncBarVisibility();
    paintReceipt(cart);
    syncRows();
  }
  function refreshCart(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){ paintCart(c); return c; })
      .catch(function(){ return null; });
  }
  root.addEventListener('tpsb:add-result', function(){ refreshCart(); });
  /* the theme drawer's own remove / quantity edits publish cartUpdate; reconcile the cards from it */
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate){ /* top-level const is never on window (director 5 Oct) */
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(){ refreshCart(); });
    }
  } catch(err){}

  /* VIEW CART opens THE THEME'S drawer (the bottom bar's button, the one cart control).
     If the custom element has not upgraded, fall back to /cart rather than a
     dead control. */
  function openThemeCart(fromEl){
    var drawer = document.querySelector('cart-drawer');
    var openFn = drawer && (drawer.__fbv2RealOpen || drawer.open);
    if (drawer && typeof openFn === 'function'){ openFn.call(drawer, fromEl || viewBtn); return; }
    window.location.href = CART_URL;
  }
  if (viewBtn) viewBtn.addEventListener('click', function(){ openThemeCart(viewBtn); });

  /* sticky offsets track the mandated band's REAL rendered height live */
  var bandEl = document.querySelector('.tps-board-warn--sticky') ||
               document.querySelector('.tps-board-warn__art');
  function setBand(){
    if (!bandEl) return;
    var h = bandEl.getBoundingClientRect().height;
    if (h > 0) root.style.setProperty('--fbv2-band', h + 'px');
  }
  if (bandEl){
    setBand();
    if (window.ResizeObserver) new ResizeObserver(setBand).observe(bandEl);
    window.addEventListener('resize', setBand);
    if (document.fonts && document.fonts.ready && document.fonts.ready.then){ document.fonts.ready.then(setBand); }
  }

  /* The bar is fixed. In Board view it retires once the price list leaves the
     viewport so it does not cover the theme footer. Form view and the filter
     sheet keep it while the cart has items — checkout must stay one tap away. */
  if (barEl && pageEl && window.IntersectionObserver){
    new IntersectionObserver(function(en){
      PAGE_IN_VIEW = !!(en[0] && en[0].isIntersecting);
      syncBarVisibility();
    }).observe(pageEl);
  }

  /* ---------- Age-gate arrival reset.
     Root cause (instrumented 5 Sep): with the gate overlay up the page ALREADY
     sits scrolled (~273px measured) at load — before any interaction — so on
     release the masthead surfaces beheaded under the fixed band. The reliable
     release marker is the `tps-age-ok` class the gate stamps on <html>. When
     that class APPEARS during this page's life the scroll is pinned to the top
     through a 1.2s settle window (defeats any late focus-scroll). A returning
     customer whose <html> already carries the marker gets a native arrival.
     Instant — not motion. ---------- */
  (function(){
    var html = document.documentElement;
    function ok(){ return (' ' + html.className + ' ').indexOf(' tps-age-ok ') >= 0; }
    if (ok()) return;
    var gi = setInterval(function(){
      if (ok()){
        clearInterval(gi);
        var until = Date.now() + 1200;
        (function settle(){
          if ((window.pageYOffset || 0) > 0) window.scrollTo(0, 0);
          if (Date.now() < until) setTimeout(settle, 150);
        })();
      }
    }, 200);
    setTimeout(function(){ clearInterval(gi); }, 600000);
  })();

  /* DD-NARROW: belt for the section's pre-paint rule (data-ddpre); its own script removes it after the board, but if
     that ever failed the rule would hide other makers' cards for good */
  var ddPre = root.querySelector('style[data-ddpre]'); if (ddPre && ddPre.parentNode) ddPre.parentNode.removeChild(ddPre);
  /* DD-NARROW boot: a page that opens in Dropdown view narrows the board to the plate's maker before first paint of
     the narrowed state. A ?brand= link (one maker, written by writeURL) wins over the remembered maker. */
  if (isForm() && !BRAND_PAGE && qBrand){
    var ub = keys(S.brand);
    if (ub.length === 1 && qBrand.value !== ub[0]){
      var sv = loadFormSel();
      qBrand.value = ub[0];
      onBrandChange(sv.b === ub[0] ? sv : {});
    } else ddNarrow();
  } else render();
  refreshCart();
  /* ---- BODY END ---- */
  }
  var roots = document.querySelectorAll('section[data-fbv2]');
  for (var i = 0; i < roots.length; i++) fbv2Boot(roots[i]);
  /* theme editor: a re-rendered section brings fresh markup; the old inline script re-ran with it */
  document.addEventListener('shopify:section:load', function(e){
    var r = e.target && e.target.querySelector ? e.target.querySelector('section[data-fbv2]') : null;
    if (r) fbv2Boot(r);
  });
})();
